import Reaact from "react";
import SellerBanner from "../../../subscreens/customer/home/sellerbanner/Sellerbanner";
import MyNavbar from "../../../components/general/mynavbar/MyNavbar";

const BecomeSeller=()=>{
    return(
        <>
        <MyNavbar />
<SellerBanner />

        </>
    )
}
export default BecomeSeller;